import { render, staticRenderFns } from "./SimpleNote3.vue?vue&type=template&id=6cec6816&"
import script from "./SimpleNote3.vue?vue&type=script&lang=js&"
export * from "./SimpleNote3.vue?vue&type=script&lang=js&"
import style0 from "./SimpleNote3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports